import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTimeSeries = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M4 16v-2M10 16V9M7 16v-5M13 16v-5M16 16V6.5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={0.5}
      d="M17.104 3c-6.883-.15-6.749 5.174-14.862 5"
    />
  </svg>
);
export default SvgTimeSeries;
